import { cn } from '@parcel/ui';
import { CreditCard } from 'lucide-react';
import { getWorkspaceScopedPath } from '../app-sidebar-nav.js';

export function InsufficientCreditsNotice({
  compact = false,
  reason = 'credits',
}: {
  compact?: boolean;
  reason?: 'credits' | 'spend_limit';
}) {
  // A plain anchor: the drawer mounts app-wide, and Billing is a full load anyway.
  const href = getWorkspaceScopedPath(
    window.location.pathname,
    reason === 'credits' ? '/settings/billing' : '/settings/usage',
  );
  return (
    <output
      data-testid="enrich-credits-notice"
      className={cn(
        'flex items-center gap-1.5 text-destructive',
        compact
          ? 'text-xs'
          : 'rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm',
      )}
    >
      <CreditCard className="size-3.5 shrink-0" aria-hidden />
      <span>{reason === 'credits' ? 'Out of enrichment credits.' : 'Spend limit reached.'}</span>
      <a
        href={href}
        onClick={(event) => event.stopPropagation()}
        className="font-medium underline underline-offset-2"
      >
        {reason === 'credits' ? 'Buy credits' : 'Raise it'}
      </a>
    </output>
  );
}
